module.exports = {"id":"191198","name":"Ivan Obradović","rating":"73","photo":"./data/images/photos/0/191198.png","club":{"name":"RSC Anderlecht","logo":"./data/images/clubs/RSCAnderlecht.png"},"positions":["DG","DLG","DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IvanObradovic0.json
// module id = 1844
// module chunks = 0